import { type ITransaction } from '@app/purchase/transaction/models/Transaction';
import type { MultiObjectInclude, SingleObjectInclude } from '@shared/types/ApiResponse';
import type { CreateRoute, DestroyRoute, EditRoute, IndexRoute, ShowRoute, StoreRoute, UpdateRoute } from '@shared/types/Route';
import { PayoutEvent, type IPayoutEvent } from '@app/purchase/bundle/models/PayoutEvent';
import type { ISteward } from '@app/land-hold/steward/models/Steward';
import type { IPayout } from '@app/purchase/payout/models/Payout';
import type { IOwner } from '@app/land-hold/owner/models/Owner';
import type { IBlock } from '@app/purchase/block/models/Block';

export enum AvailableIncludes {
    Transactions = 'transactions',
    Steward = 'steward',
}

export interface TransactionsInclude {
    transactions: MultiObjectInclude<ITransaction>;
}
export interface StewardInclude {
    steward: SingleObjectInclude<ISteward>;
}

export interface PayoutWithIncludes extends IPayout {
    owner?: SingleObjectInclude<IOwner>;
    block?: SingleObjectInclude<IBlock>;
    transaction?: SingleObjectInclude<ITransaction>;
}

export interface PayoutsInclude {
    payouts?: MultiObjectInclude<PayoutWithIncludes>;
}
export interface PayoutEventOwnerSummary {
    id: string;
    name: string;
    properties_count: number;
    transactions_count: number;
    blocks_count: number;
    total_carbon: number;
    total_payout: number;
    pending_payout_count: number;
}

export interface OwnersInclude {
    owners?: MultiObjectInclude<PayoutEventOwnerSummary>;
}

export interface EligibleOwner {
    id: string;
    name: string;
    project_name: string | null;
    pending_payout_count: number;
}

export type AllPayoutEventIncludes = IPayoutEvent & TransactionsInclude & StewardInclude;
export type IndexPayoutEventIncludes = IPayoutEvent & TransactionsInclude & StewardInclude;
export type ShowPayoutEventIncludes = IndexPayoutEventIncludes & PayoutsInclude & OwnersInclude;

export function routes(): {
    index: IndexRoute<'bundles.index', IndexPayoutEventIncludes>;
    show: ShowRoute<'bundles.show', ShowPayoutEventIncludes>;
    destroy: DestroyRoute<'bundles.destroy'>;
    create: CreateRoute<'bundles.create'>;
    store: StoreRoute<'bundles.store'>;
    edit: EditRoute<'bundles.edit'>;
    update: UpdateRoute<'bundles.update'>;
} {
    return {
        index: {
            method: 'get',
            name: 'bundles.index',
            params: { include: [AvailableIncludes.Transactions, AvailableIncludes.Steward], orderBy: 'created_at', sortedBy: 'desc' },
            datatableHeaders: () => PayoutEvent.headers(),
            page: usePage(),
        },
        show: { method: 'get', name: 'bundles.show', params: { include: [AvailableIncludes.Transactions, AvailableIncludes.Steward] }, page: usePage() },
        destroy: { method: 'delete', name: 'bundles.destroy', page: usePage() },
        create: { method: 'get', name: 'bundles.create', page: usePage() },
        store: { method: 'post', name: 'bundles.store', page: usePage() },
        edit: { method: 'get', name: 'bundles.edit', page: usePage() },
        update: { method: 'patch', name: 'bundles.update', page: usePage() },
    };
}
